import React from 'react';
import {
  ReceiptText,
  AlertTriangle,
  Divide,
  CheckCircle2,
  Home,
  Droplets
} from 'lucide-react';
import { useGetUngeneratedInvoicesQuery } from '../../lib/apiSlice/invoicing/invoicingSlice.tsx';

export default function GenerateInvoiceMetrics({ month, year }) {
  // Get current month name in lowercase (e.g. "may")
  const currentMonth = new Date().toLocaleString('default', { month: 'long' }).toLowerCase();
  const currentYear = new Date().getFullYear().toString(); // e.g. "2025"
  const selectedMonth = month || currentMonth;
  const selectedYear = year || currentYear;
  
  // Fetch data with current month and year
  const { data: invoiceData, isLoading, error } = useGetUngeneratedInvoicesQuery({
    month: selectedMonth,
    year: selectedYear
  });

  const cards = [
    {
      title: 'Total Invoices',
      value: invoiceData?.summary?.total_invoices || 0,
      icon: <ReceiptText className="w-10 h-10 text-blue-600" fill="currentColor" />,
      bgColor: '#DBEAFE',
      shadowColor: '#DBEAFE',
    },
    {
      title: 'Unpaid Invoices',
      value: invoiceData?.summary?.unpaid_invoices || 0,
      icon: <AlertTriangle className="w-10 h-10 text-red-600" fill="currentColor" />,
      bgColor: '#FECACA',
      shadowColor: '#FECACA',
    },
    {
      title: 'Partially Paid',
      value: invoiceData?.summary?.partial_invoices || 0,
      icon: <Divide className="w-10 h-10 text-yellow-500" fill="currentColor" />,
      bgColor: '#FEF9C3',
      shadowColor: '#FEF9C3',
    },
    {
      title: 'Paid Invoices',
      value: invoiceData?.summary?.paid_invoices || 0,
      icon: <CheckCircle2 className="w-10 h-10 text-green-600" fill="currentColor" />,
      bgColor: '#D1FAE5',
      shadowColor: '#D1FAE5',
    },
    {
      title: 'Missing Rent Invoices',
      value: invoiceData?.summary?.missing_rent_invoices || 0,
      icon: <Home className="w-10 h-10 text-purple-600" fill="currentColor" />,
      bgColor: '#EDE9FE',
      shadowColor: '#EDE9FE',
    },
    {
      title: 'Missing Utility Invoices',
      value: invoiceData?.summary?.missing_expense_invoices || 0,
      icon: <Droplets className="w-10 h-10 text-cyan-600" fill="currentColor" />,
      bgColor: '#CFFAFE',
      shadowColor: '#CFFAFE',
    }
  ];

  if (isLoading) {
    return <div className="mt-2 p-4 w-full text-center"></div>;
  }

  if (error) {
    return (
      <div className="mt-2 p-4 w-full text-red-600 text-center">
      </div>
    );
  }

  return (
    <div className="mt-2 w-full">
 
      <div className="gap-4 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 px-2">
        {cards.map((card, index) => (
          <div
            key={index}
            style={{
              minHeight: '50px',
              backgroundColor: card.bgColor,
              boxShadow: `${card.shadowColor} 10px 11px 25px 1px`
            }}
            className="p-4 rounded-3xl text-gray-800 transition-all"
          >
            <div className="flex items-start">
              <div className="flex justify-center items-center bg-white mr-3 p-3 rounded-full w-20 h-20">
                {card.icon}
              </div>
              <div className="flex-1">
                <h3 className="font-medium text-sm">{card.title}</h3>
                <p className="mt-1 font-bold text-3xl">{card.value}</p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
